import { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Mission & Vision Section - full width, no image (for homepage)
const MissionVisionSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      ref={ref}
      data-testid="mission-vision-section"
      className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-[#FAFAFA]"
    >
      <div className="max-w-4xl mx-auto">
        <div className="space-y-8">
          {/* Mission */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <h2 
              data-testid="mission-title"
              className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Our Mission
            </h2>
            <p 
              data-testid="mission-text"
              className="text-[#666666] text-base md:text-lg leading-relaxed"
            >
              Murphy's Giving Market is a largely volunteer organization that primarily serves people in poverty in Upper Darby and surrounding areas. We provide fresh, healthful, and culturally appropriate food options, clothing, and hygiene products; facilitate access to a wide network of resources; and empower clients to create long-lasting changes in their lives and communities.
            </p>
          </motion.div>

          {/* Vision */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 
              data-testid="vision-title"
              className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Our Vision
            </h2>
            <p 
              data-testid="vision-text"
              className="text-[#666666] text-base md:text-lg leading-relaxed"
            >
              Murphy's Giving Market envisions a healthy, collaborative, and thriving community.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;
